import type { ScreenTab } from '@/components/layout/screenTabs'

/**
 * The three tab bars in the mockups. Shared here because sibling tabs are
 * separate route components — each tab owns its own data lifecycle, so leaving a
 * tab unmounts its polling — which would otherwise mean each one redeclaring the
 * whole bar.
 */
export const HOME_TABS: ScreenTab[] = [
  { name: 'track', label: 'Track a bus' },
  { name: 'plan', label: 'Search route' },
]

export const STOP_TABS: ScreenTab[] = [
  { name: 'stop-buses', label: 'Bus at bus stop' },
  { name: 'stop-routes', label: 'Passing route' },
]

export const LOOKUP_TABS: ScreenTab[] = [
  { name: 'lookup-routes', label: 'Bus route' },
  { name: 'lookup-stops', label: 'Bus stop' },
]
